"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.msalConfig = void 0;
var _msalBrowser = require("@azure/msal-browser");
/* eslint-disable no-console */

const crypto = require('crypto');
Object.defineProperty(window, 'crypto', crypto);
const redirectUri = window.location.origin;
const msalConfig = exports.msalConfig = {
  auth: {
    clientId: '',
    authority: 'https://login.microsoftonline.com/72ca17d4-d1db-496b-8e11-2617ae372f4f',
    redirectUri,
    navigateToLoginRequestUrl: false,
    validateAuthority: true,
    postLogoutRedirectUri: "".concat(window.location.origin)
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false
  },
  system: {
    loggerOptions: {
      logLevel: _msalBrowser.LogLevel.Trace,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case _msalBrowser.LogLevel.Error:
            console.error(message);
            return;
          case _msalBrowser.LogLevel.Info:
            console.info(message);
            return;
          case _msalBrowser.LogLevel.Verbose:
            console.debug(message);
            return;
          case _msalBrowser.LogLevel.Warning:
            console.warn(message);
            return;
          default:
        }
      }
    },
    loadFrameTimeout: 30000
    // iframeHashTimeout: 10,
    // tokenRenewalOffsetSeconds: 300,
    // navigateFrameWait: 500,
  }
};